interface WindowWithReactGA extends Window {
  gtag?: Function;
}

const windowObject = window as WindowWithReactGA;

export function reportEvent(eventType: string, eventPayload: object = {}) {
  windowObject?.gtag?.('event', eventType, eventPayload);
}

export function reportPage(location: { pathname: string; search: string }) {
  windowObject?.gtag?.({ hitType: 'pageview', page: location.pathname + location.search });
}
